import { render } from "./Paystubs.vue?vue&type=template&id=22c520e6"
import script from "./Paystubs.vue?vue&type=script&lang=js"
export * from "./Paystubs.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "22c520e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('22c520e6', script)) {
    api.reload('22c520e6', script)
  }
  
  module.hot.accept("./Paystubs.vue?vue&type=template&id=22c520e6", () => {
    api.rerender('22c520e6', render)
  })

}

script.__file = "src/components/Paystubs.vue"

export default script